window.Views = {
    Example: require('./views/example'),
    ScheduleCreator: require('./views/schedule_creator'),
    ManufacturerEdit: require('./views/manufacturer_edit'),
    OrderEdit: require('./views/order_edit'),
    Scheduler: require('./views/scheduler'),
    Dashboard: require('./views/dashboard')
};
